<template>
  <div class="contadores-view">
    <v-row align="stretch">
      <v-col cols="12" md="5" lg="4">
        <div class="sidebar-shell">
          <ContadoresList
            :contadores="contadores"
            :caudalSensores="caudalSensores"
            :selected-item="selectedItem"
            @select="selectItem"
          />
        </div>
      </v-col>

      <v-col cols="12" md="7" lg="8">
        <v-card v-if="!selectedItem" class="placeholder-card" elevation="1">
          <v-card-text class="pa-6">
            <div class="placeholder-kicker">
              <v-icon size="18" color="teal darken-2">mdi-chart-timeline-variant</v-icon>
              <span>Vista de detalle</span>
            </div>
            <div class="placeholder-title">Selecciona un contador para ver su gráfica</div>
            <p class="placeholder-description mb-0">
              Selecciona un contador o sensor de la lista de la izquierda.
            </p>
          </v-card-text>
        </v-card>

        <ContadoresChart
          v-else
          :item="selectedItem"
          @clear-contador="clearItem"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ContadoresList from "@/components/ContadoresList.vue";
import ContadoresChart from "@/components/ContadoresChart.vue";
import { getContadores } from "@/data/contadoresData";
import { getCaudalSensores } from "@/data/caudalSensoresData";

export default {
  components: { ContadoresList, ContadoresChart },
  data() {
    return {
      contadores: getContadores(),
      caudalSensores: getCaudalSensores(),
      selectedItem: null,
    };
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item;
    },
    clearItem() {
      this.selectedItem = null;
    },
  },
};
</script>

<style scoped>
.contadores-view {
  min-height: 100%;
}

.sidebar-shell {
  position: sticky;
  top: 24px;
}

.placeholder-card {
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(255, 255, 255, 0.97);
}

.placeholder-kicker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #0f766e;
}

.placeholder-title {
  margin-top: 18px;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  color: #0f172a;
}

.placeholder-description {
  margin-top: 10px;
  color: #64748b;
  line-height: 1.7;
  max-width: 56ch;
}

@media (max-width: 959px) {
  .sidebar-shell {
    position: static;
  }
}
</style>
